import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'BaseServices/main-service';
import { EquipmentDetailDTO } from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';

@Component({
  selector: 'app-equipment-info-tab',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './equipment-info-tab.component.html',
  styleUrls: ['./equipment-info-tab.component.css'],
})
export class EquipmentInfoTabComponent implements OnInit {
  equipmentId = 0;

  equipment = {
    name: '',
    supplierName: '',
    supplierPhone: '',
    supplierAddress: '',
    model: '',
    series: '',
    purchaseDateText: '',
    departmentName: '',
    placement: '',
    responsibleName: '',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private mainService: MainService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.parent?.paramMap.subscribe((params) => {
      this.equipmentId = Number(params.get('id') ?? 0);

      if (!this.equipmentId) return;

      this.loadEquipment(this.equipmentId);
    });
  }

  private loadEquipment(id: number): void {
    this.mainService.get<EquipmentDetailDTO>('Equipment', id).subscribe({
      next: (equipment) => {
        this.populateForm(equipment);
      },
      error: (err) => {
        console.error('Could not load equipment', err);
      },
    });
  }

  private formatDate(value: unknown): string {
    if (!value) return '';

    const date = new Date(value as any);
    if (!Number.isFinite(date.getTime())) return '';

    return date.toLocaleDateString('da-DK');
  }

  private populateForm(equipment: EquipmentDetailDTO): void {
    const eq: any = equipment;

    this.equipment = {
      name: String(eq.Name ?? eq.name ?? ''),
      supplierName: String(eq.SupplierName ?? eq.supplierName ?? ''),
      supplierPhone: String(eq.SupplierPhone ?? eq.supplierPhone ?? ''),
      supplierAddress: String(eq.SupplierAddress ?? eq.supplierAddress ?? ''),
      model: String(eq.Model ?? eq.model ?? ''),
      series: String(eq.Series ?? eq.series ?? ''),
      purchaseDateText: this.formatDate(eq.PurchaseDate ?? eq.purchaseDate),
      departmentName: String(
        eq.DepartmentName ??
        eq.departmentName ??
        eq.Department?.DisplayName ??
        eq.Department?.displayName ??
        eq.Department?.DepartmentName ??
        eq.Department?.departmentName ??
        ''
      ),
      placement: String(eq.Placement ?? eq.placement ?? ''),
      responsibleName: String(
        eq.ResponsibleName ??
        eq.responsibleName ??
        eq.Responsible?.Name ??
        eq.Responsible?.name ??
        ''
      ),
    };
  }
}
